export const sinTrizaduras = (texto: any): any => {
  if (typeof texto !== 'string') return texto
  return texto.replace(/trizadura/gi, (match) => (match[0] === match[0].toUpperCase() ? 'Rotura' : 'rotura'))
}
